.section {
  container-type: inline-size;
  margin: 2rem auto 0;
  max-width: 768px;
  padding: 0;
  position: relative;
}

.frame {
  height: calc(460px * var(--card-scale, 1));
}

.card {
  background-color: var(--journey-card-bg);
  border: 1px solid rgba(15, 43, 60, 0.08);
  border-radius: 24px;
  box-sizing: border-box;
  box-shadow: var(--shadow-close);
  color: var(--journey-card-fg);
  font-size: 20px;
  display: flex;
  flex-direction: column;
  height: 460px;
  justify-content: space-between;
  overflow: hidden;
  padding: 28px 30px 24px;
  position: relative;
  transform: scale(var(--card-scale, 1));
  transform-origin: top left;
  transition: box-shadow 250ms ease-out;
  width: 768px;
  z-index: 101;
}

.card:hover {
  box-shadow: var(--shadow-primary);
}

.screenshotView,
.screenshotView:hover {
  box-shadow: none;
}

.header,
.scores,
.trust {
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 100;
}

/* The 150 px picture makes the header 58 px taller than the 116 it was, and the 96 px QR code the score row 5 px
   taller. The card spreads its rows with space-between, so the negative margin keeps the score row and the pills
   where they were. */
.header {
  align-items: flex-start;
  margin-bottom: -53px;
}

.identity {
  align-items: center;
  display: flex;
  gap: 24px;
}

/* The profile picture with a thin amber ring segment, open at the top left. */
.portrait {
  display: flex;
  flex: none;
  padding: 12px;
  position: relative;
}

.ring {
  inset: 0;
  position: absolute;
  transform: rotate(-90deg);
}

.ring circle {
  stroke: var(--color-accent);
}

.logo {
  align-items: flex-start;
  border-radius: 12px;
  display: flex;
  justify-content: center;
}

.scores {
  gap: 28px;
}

/* EmScore draws its numbers and labels in the text tokens, which are dark. On a dark card they take the card's colour. */
.dark .scores {
  --color-text: var(--journey-card-fg);
  --color-text-muted: var(--journey-card-fg);
}

.questions {
  display: flex;
  flex: 1;
  justify-content: space-between;
}

/* The 96 px QR code and its quiet zone, centred near the end of the curve at x 700. */
.qrColumn {
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 8px;
  margin-right: 8px;
  width: 111px;
}

.qrCode {
  display: block;
  width: fit-content;
  /* Quiet zone around the QR code, so it scans on any card colour. */
  padding: 0.375em;
  line-height: 0;
  text-align: center;
}

.caption {
  align-items: center;
  color: var(--journey-card-caption);
  display: flex;
  font-size: 12px;
  font-weight: 600;
  gap: 4px;
  white-space: nowrap;
}

.pills {
  display: flex;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pill {
  align-items: center;
  background: var(--color-surface);
  /* A thin edge, not a shadow: html2canvas draws the shadow square under a round pill. */
  border: 1px solid rgba(15, 43, 60, 0.12);
  border-radius: 15px;
  color: var(--color-primary);
  display: flex;
  font-size: 13px;
  gap: 6px;
  line-height: 1;
  padding: 8px 12px;
  white-space: nowrap;
}

/* Partly outside the corner, fading out towards the middle and the left. */
.dots {
  display: flex;
  pointer-events: none;
  position: absolute;
  right: -30px;
  top: -30px;
  z-index: 1;
}

@media (prefers-reduced-motion: reduce) {
  .card {
    transition: none;
  }
}

/* The 768 card behind the stacked one on a narrow screen: drawn at full size for the screenshots, never seen. */
.offscreen {
  left: -10000px;
  pointer-events: none;
  position: absolute;
  top: 0;
}
